var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPin = function SvgIconPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.167v4.167",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 14.167h11.666V12.7a1.667 1.667 0 0 0-.925-1.491l-1.483-.75a1.667 1.667 0 0 1-.925-1.492V5h.833a1.667 1.667 0 0 0 0-3.333H6.666a1.667 1.667 0 0 0 0 3.333H7.5v3.967a1.667 1.667 0 0 1-.925 1.492l-1.484.75a1.666 1.666 0 0 0-.925 1.491v1.467Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconPin;